<template>
  <div class="json-viewer">
    <div class="json-content">
      <JsonProperty
        :data="data"
        :property-key="null"
        :key-path="null"
        :depth="0"
        :has-changes="hasChanges"
        :original-value="originalValue"
        @update="(keyPath, newValue) => $emit('update', keyPath, newValue)"
      />
    </div>
  </div>
</template>

<script setup>
  import JsonProperty from './JsonProperty.vue'

  defineProps({
    data: {
      type: Object,
      required: true,
    },
    hasChanges: {
      type: Boolean,
      default: false,
    },
    originalValue: {
      type: Object,
      default: null,
    },
  })

  defineEmits(['update'])
</script>

<style scoped>
  .json-viewer {
    background-color: #1e1e1e;
    border: 1px solid #3c3c3c;
    border-radius: 4px;
    font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
    font-size: 13px;
    line-height: 1.4;
    overflow: auto;
    max-height: 80vh;
  }

  .json-content {
    padding: 12px;
    color: #d4d4d4;
  }
</style>
